<template>
  <div class="positive-rate">
    <template v-if="!item || item.totalCount == 0">
      <span class="positive-rate__square--none" />
      <div class="value">
        <div class="value__ratio">-</div>
        <div class="value__count">（{{ item.totalCount }}回）</div>
      </div>
    </template>
    <template v-else-if="item.positiveCount == 0 && item.negativeCount == 0">
      <span class="positive-rate__square--white" />
      <div class="value">
        <div class="value__ratio">中立</div>
        <div class="value__count">（{{ item.totalCount }}回）</div>
      </div>
    </template>
    <template v-else>
      <span :class="`positive-rate__square--${ evaluationColor(positiveRate(item)) }`" />
      <div class="value">
        <div class="value__ratio">{{ positiveRate(item) }}</div>
        <div class="value__count">（{{ item.totalCount }}回）</div>
      </div>
    </template>
  </div>
</template>

<script>
import localeStringMixin from '../../../../mixins/localeStringMixin'

export default {
  name: 'CompaniesAnalysisKeywordsComparisonRate',
  mixins: [localeStringMixin],
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    total(item) {
      return item.positiveCount + item.negativeCount
    },
    positiveRate(item) {
      return this.total(item) == 0 ? 0 : Math.ceil((item.positiveCount / this.total(item)) * 100)
    },
    evaluationColor(num) {
      switch (true) {
      case 80 < num && num <= 100:
        return 'color1'
      case 60 < num && num <= 80:
        return 'color2'
      case 40 < num && num <= 60:
        return 'color3'
      case 20 < num && num <= 40:
        return 'color4'
      case 0 <= num && num <= 20:
        return 'color5'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.positive-rate {
  display: flex;
  align-items: center;
  %__square {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 15px;
  }
  &__square {
    &--color1 {
      @extend %__square;
      background: #4C959A;
    }

    &--color2 {
      @extend %__square;
      background: #8CC0C0;
    }

    &--color3 {
      @extend %__square;
      background: #D2D5DB;
    }

    &--color4 {
      @extend %__square;
      background: #EEAEBF;
    }

    &--color5 {
      @extend %__square;
      background: #E9446A;
    }

    &--white {
      @extend %__square;
      background: #fff;
      border: #e4e7eb solid 1px;
    }

    &--none {
      @extend %__square;
      display: none;
    }
  }
}
.value {
  line-height: 1;
  &__count {
    margin-top: 6px;
    color: #6D7381;
    font-size: 10px;
    text-indent: -1em;
  }
}
</style>
